import script from "./KeyValTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./KeyValTemplate.vue?vue&type=script&setup=true&lang=js"

import "./KeyValTemplate.vue?vue&type=style&index=0&id=20a0a1e6&lang=scss&scoped=true"

import exportComponent from "E:\\Projects\\big-screen\\ori\\nnu-data-viewer-1204\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20a0a1e6"]])

export default __exports__